export const DATE_VALID = 2;
export const DATE_UNDER_18 = 1;
export const DATE_INVALID = 0;
